const form = {
  formId: "new-user-form",
  formField: {
    companyName: {
      name: "companyName",
      label: "[1] Tên công ty",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên công ty",
    },
    companyTaxId: {
      name: "companyTaxId",
      label: "[2] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAuthorities: {
      name: "taxAuthorities",
      label: "[3] Cơ quan Thuế quản lý",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên cơ quan Thuế quản lý",
    },
    numberSupplier: {
      name: "numberSupplier",
      label: "[4] Tổng số lượng nhà cung cấp",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập số lượng nhà cung cấp",
    },
    numberSupplierAuthority: {
      name: "numberSupplierAuthority",
      label: "[5] Tổng số lượng nhà cung cấp đã ủy quyền khai thay",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập số lượng nhà cung cấp đã ủy quyền khai thay",
    },
    //
    period: {
      name: "period",
      label: "Kỳ dữ liệu",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập kỳ dữ liệu",
    },
    firstTime: {
      name: "firstTime",
      label: "Lần đầu",
      type: "text",
    },
    replaceNumber: {
      name: "replaceNumber",
      label: "Thay thế lần",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập lần thay thế",
    },

    //--------------//
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên nhân viên đại lý thuế",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập số chứng chỉ hành nghề",
    },
  },
};

export default form;
